import React from "react";
import { PageHero } from "../components/PageHero";
import { useLang } from "../i18n";
import { siteConfig, orComingSoon } from "../config/siteConfig";

const copy = {
  en: {
    over: "Legal", title: "Terms & Conditions",
    badge: "Draft — full terms coming soon",
    intro: "These preliminary Terms & Conditions govern your use of the WANM — We Are Nation Media website. Complete, legally reviewed terms will be published once WANM's official corporate details are established.",
    sections: [
      { h: "Use of this website", p: "This website is provided for informational and business-development purposes. By using it, you agree to use it lawfully and not to misuse its forms or content." },
      { h: "Partnerships", p: "Submitting a brand or publisher form is an expression of interest and does not create a binding partnership. Any partnership is subject to a separate agreement." },
      { h: "No guarantees", p: "WANM makes no guarantee of earnings, approval, or specific performance outcomes. Results depend on many factors outside our control." },
      { h: "Intellectual property", p: "The WANM name, logo and brand assets are the property of WANM and may not be used without permission." },
      { h: "Contact", p: "For questions about these terms, contact us at:" },
    ],
  },
  es: {
    over: "Legal", title: "Términos y Condiciones",
    badge: "Borrador — términos completos próximamente",
    intro: "Estos Términos y Condiciones preliminares rigen el uso del sitio web de WANM — We Are Nation Media. Se publicarán términos completos y revisados legalmente una vez que se establezcan los datos corporativos oficiales de WANM.",
    sections: [
      { h: "Uso de este sitio web", p: "Este sitio se proporciona con fines informativos y de desarrollo de negocio. Al usarlo, aceptas hacerlo de forma lícita y no hacer un uso indebido de sus formularios o contenido." },
      { h: "Alianzas", p: "Enviar un formulario de marca o publisher es una expresión de interés y no crea una alianza vinculante. Cualquier alianza está sujeta a un acuerdo por separado." },
      { h: "Sin garantías", p: "WANM no garantiza ganancias, aprobación ni resultados de rendimiento específicos. Los resultados dependen de muchos factores fuera de nuestro control." },
      { h: "Propiedad intelectual", p: "El nombre, el logotipo y los activos de marca de WANM son propiedad de WANM y no pueden usarse sin permiso." },
      { h: "Contacto", p: "Para preguntas sobre estos términos, contáctanos en:" },
    ],
  },
};

const Terms = () => {
  const { lang } = useLang();
  const c = copy[lang] || copy.en;
  const email = orComingSoon(siteConfig.legal.contactEmail || siteConfig.contact.email);
  return (
    <div>
      <PageHero over={c.over} title={c.title} />
      <section className="py-16 md:py-24 bg-white">
        <div className="mx-auto max-w-3xl px-5 md:px-10">
          <span className="inline-block text-xs font-black uppercase tracking-widest text-wanm-orange bg-wanm-offwhite rounded-full px-4 py-2 mb-8">{c.badge}</span>
          <p className="text-lg text-wanm-dark/70 leading-relaxed mb-10">{c.intro}</p>
          <div className="space-y-10">
            {c.sections.map((s, i) => (
              <div key={i}>
                <h2 className="text-2xl md:text-3xl font-black text-wanm-dark mb-3">{s.h}</h2>
                <p className="text-wanm-dark/70 leading-relaxed text-lg">{s.p}</p>
                {(s.h === "Contact" || s.h === "Contacto") && <p className="mt-2 font-bold text-wanm-red">{email}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
